const ICON_STYLE = {
  width: 24,
  height: 24,
  display: "block",
};

function Base({ children, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      aria-hidden="true"
      focusable="false"
      style={ICON_STYLE}
      {...props}
    >
      {children}
    </svg>
  );
}

export default function ContactIcon({ name }) {
  switch (name) {
    case "location":
      return (
        <Base>
          <path
            d="M12 21s6-5.3 6-10.2A6 6 0 1 0 6 10.8C6 15.7 12 21 12 21Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <circle cx="12" cy="10.8" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
        </Base>
      );
    case "phone":
      return (
        <Base>
          <path
            d="M8.1 4.8 6.9 3.6c-.5-.5-1.3-.5-1.8 0L3.8 4.9c-.8.8-1.1 2-.7 3.1 1.4 3.6 4.6 6.8 8.2 8.2 1 .4 2.3.1 3.1-.7l1.3-1.3c.5-.5.5-1.3 0-1.8l-1.2-1.2c-.4-.4-1-.5-1.5-.2l-1.1.6c-.3.2-.7.1-.9-.1l-2.8-2.8c-.2-.2-.2-.6-.1-.9l.6-1.1c.3-.5.2-1.1-.2-1.5Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );
    case "email":
      return (
        <Base>
          <path
            d="M4 6.5h16v11H4z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="m4.8 7.2 7.2 6 7.2-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </Base>
      );
    case "hours":
      return (
        <Base>
          <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="1.8" />
          <path
            d="M12 7.8V12l3.1 2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </Base>
      );
    default:
      return (
        <Base>
          <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
        </Base>
      );
  }
}

